export default __webpack_public_path__ + "static/media/Senthivel C.5366d9d8.jpg";